import { WebObjectModel } from './web-object-model';
import { TargetCandidate } from './web-recorded-command-model';

// Rebuilds the "Element Details" candidate list from a backend-resolved
// WebObjectModel (CTVModel.target) — used where there's no pre-flattened
// WebRecordedCommand.targetCandidates to reuse, e.g. WebRecorderSavedStepsComponent.
export function webObjectToCandidates(target: WebObjectModel | undefined | null): TargetCandidate[] {
  if (!target) return [];
  const candidates: TargetCandidate[] = [];
  if (target.xpath) candidates.push({ label: 'xpath', value: target.xpath });
  if (target.css) candidates.push({ label: 'css', value: target.css });
  if (target.dom_id) candidates.push({ label: 'id', value: target.dom_id });
  if (target.dom_name) candidates.push({ label: 'name', value: target.dom_name });
  if (target.link) candidates.push({ label: 'link', value: target.link });
  if (target.partial_link) candidates.push({ label: 'partial link', value: target.partial_link });
  if (target.horizontal_index) candidates.push({ label: 'horizontal index', value: target.horizontal_index });
  (target.xpaths || [])
    .filter(x => x && x !== target.xpath)
    .forEach(x => candidates.push({ label: 'xpath (alternate)', value: x }));
  return candidates;
}
